import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
    backgroundColor: '#fff',
    color: '#000',
    boxShadow: 'none',
    borderBottom: '1px solid #C4C4C4',
  },
  title: {
    margin: '0 auto',
  },
}));

export const ImageCropHeader = ({ setOpen }) => {
  const classes = useStyles();

  return (
    <AppBar className={classes.appBar}>
      <Toolbar>
        <Typography variant='h6' className={classes.title}>
          Crop Image
        </Typography>
        <IconButton
          edge='start'
          color='inherit'
          onClick={() => {
            setOpen(false);
          }}
          aria-label='close'
        >
          <CloseIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};
